/* eslint-disable */
export const es = {
    'QR код': 'Código QR',
    Бейдж: 'Insignia',
    'Виджет с картой': 'Widget con mapa',
    Кнопка: 'Botón',
    Ссылка: 'Enlace',
    'widgetgenerator.erip.tooltip':
        "Es un código especial que se genera y asigna para todos los anuncios publicados en línea. El código es público, es decir, pueden usarlo todos los usuarios de la web, y está incrustado en los parámetros del enlace. Encontrarás el código ERID en tu <a href='https://distribution.yandex.ru/v2/create/partner/go?utm_source=widget_generator'>cuenta</a> de Yandex Distribution",
    'widgetgenerator.legal.url.yandex': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.legal.url.yango': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.modal.continue': 'Continuar',
    'widgetgenerator.modal.message':
        'El tipo de widget Widget con mapa no es compatible con esta dirección. Usa otro formato de widget',
    'widgetgenerator.yandex.badge.orderInYandex': 'Pedir con Yandex Go',
    'widgetgenerator.yandex.defaultAddress': '16 Lva Tolstogo St., Moscú, Federación de Rusia',
    'widgetgenerator.yango.badge.getRidetitle': 'Pide un viaje',
    'widgetgenerator.yango.badge.orderInYango': 'Pedir con Yango',
    'widgetgenerator.yango.defaultAddress':
        'Aeropuerto Internacional de Dubái, Deira, Dubái, Emiratos Árabes Unidos',
    Адрес: 'Dirección',
    'Адрес сайта или CLID партнерской программы':
        'Dirección del sitio web o CLID del programa de empresas asociadas',
    'Без адреса': 'Sin dirección',
    Бизнес: 'Business',
    'Введите авторизационные данные для доступа к API. Получить их можно':
        'Ingresa las credenciales para acceder a la API. Puedes obtenerlas',
    'Вызвать такси': 'Pide un viaje',
    'Генератор виджета': 'Generador del widget',
    'Доехать на такси': 'Conseguir un viaje',
    Заголовок: 'Título',
    Загрузить: 'Cargar',
    Комфорт: 'Confort',
    Копировать: 'Copiar',
    Куда: 'Hacia',
    'Маршрут, встроенный в ссылку': 'Ruta incrustada en el enlace',
    Минивен: 'Minivan',
    'Нажимая «Получить код» вы соглашаетесь с':
        'Al hacer clic en Obtener código, estarás aceptando los',
    'Невозможно выбрать тариф: регион не поддерживается':
        'El tipo de servicio no está disponible en la región',
    'Неправильный адрес': 'Dirección no válida',
    'Новый виджет': 'Widget nuevo',
    Откуда: 'Desde',
    Подзаголовок: 'Subtítulo',
    'Получить код': 'Obtener código',
    'Скачать QR код': 'Descargar código QR',
    'Скопируйте код и установите на сайте': 'Copia el código e incrústalo en tu sitio',
    Стиль: 'Estilo',
    Стоимость: 'Precio',
    Тариф: 'Tipo de servicio',
    'Текст успешно скопирован': 'Texto copiado',
    'Указанный адрес': 'Dirección ingresada',
    'Фоновое изображение': 'Imagen de fondo',
    Цена: 'Precio',
    Эконом: 'Económico',
    'Это поле обязательно': 'Campo obligatorio',
    'оставив заявку': 'al hacer un pedido',
    'условиями использования': 'Términos de uso',
};
